<script type="text/ecmascript-6">
    import DesignerQuestionSelectDoor from "../DesignerQuestionSelectDoor.vue";

    export default {
        mixins: [
            DesignerQuestionSelectDoor,
        ],
        props: {
            title: {
                default(){
                    return 'Choose Your Door Design';
                }
            }
        }
    }
</script>
